import { render, staticRenderFns } from "./TypeControl.vue?vue&type=template&id=537ec562&scoped=true"
import script from "./TypeControl.vue?vue&type=script&lang=js"
export * from "./TypeControl.vue?vue&type=script&lang=js"
import style0 from "./TypeControl.vue?vue&type=style&index=0&id=537ec562&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ec562",
  null
  
)

export default component.exports